/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  ChangePasswordBody,
  LoginRequest,
  LoginResponse,
  LogoutBody,
  MessageResponse,
  RefreshBody,
  RefreshResponse,
  RevokeAllTokens200,
  RevokeAllTokensBody
} from '.././models';

import { apiClient } from '../../client';




/**
 * @summary Emergency kill switch — revoke every access/refresh token on the entire platform. Requires {"confirm": "REVOKE_ALL"} in the body — this has zero blast-radius limiting otherwise.
 */
export const revokeAllTokens = (
    revokeAllTokensBody: RevokeAllTokensBody,
 signal?: AbortSignal
) => {
      
      
      return apiClient<RevokeAllTokens200>(
      {url: `/api/v1/auth/revoke-all-tokens`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: revokeAllTokensBody, signal
    },
      );
    }
  


export const getRevokeAllTokensMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeAllTokens>>, TError,{data: RevokeAllTokensBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof revokeAllTokens>>, TError,{data: RevokeAllTokensBody}, TContext> => {

const mutationKey = ['revokeAllTokens'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeAllTokens>>, {data: RevokeAllTokensBody}> = (props) => {
          const {data} = props ?? {};

          return  revokeAllTokens(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RevokeAllTokensMutationResult = NonNullable<Awaited<ReturnType<typeof revokeAllTokens>>>
    export type RevokeAllTokensMutationBody = RevokeAllTokensBody
    export type RevokeAllTokensMutationError = unknown

    /**
 * @summary Emergency kill switch — revoke every access/refresh token on the entire platform. Requires {"confirm": "REVOKE_ALL"} in the body — this has zero blast-radius limiting otherwise.
 */
export const useRevokeAllTokens = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeAllTokens>>, TError,{data: RevokeAllTokensBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revokeAllTokens>>,
        TError,
        {data: RevokeAllTokensBody},
        TContext
      > => {

      const mutationOptions = getRevokeAllTokensMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Refresh access token using refresh token
 */
export const refresh = (
    refreshBody: RefreshBody,
 signal?: AbortSignal
) => {
      
      
      return apiClient<RefreshResponse>(
      {url: `/api/v1/auth/refresh`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: refreshBody, signal
    },
      );
    }
  


export const getRefreshMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refresh>>, TError,{data: RefreshBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof refresh>>, TError,{data: RefreshBody}, TContext> => {

const mutationKey = ['refresh'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refresh>>, {data: RefreshBody}> = (props) => {
          const {data} = props ?? {};

          return  refresh(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RefreshMutationResult = NonNullable<Awaited<ReturnType<typeof refresh>>>
    export type RefreshMutationBody = RefreshBody
    export type RefreshMutationError = unknown

    /**
 * @summary Refresh access token using refresh token
 */
export const useRefresh = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refresh>>, TError,{data: RefreshBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof refresh>>,
        TError,
        {data: RefreshBody},
        TContext
      > => {

      const mutationOptions = getRefreshMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Logout — revoke all tokens
 */
export const logout = (
    logoutBody: LogoutBody,
 signal?: AbortSignal
) => {
      
      
      return apiClient<MessageResponse>(
      {url: `/api/v1/auth/logout`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: logoutBody, signal
    },
      );
    }
  


export const getLogoutMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,{data: LogoutBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,{data: LogoutBody}, TContext> => {

const mutationKey = ['logout'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logout>>, {data: LogoutBody}> = (props) => {
          const {data} = props ?? {};

          return  logout(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LogoutMutationResult = NonNullable<Awaited<ReturnType<typeof logout>>>
    export type LogoutMutationBody = LogoutBody
    export type LogoutMutationError = unknown

    /**
 * @summary Logout — revoke all tokens
 */
export const useLogout = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,{data: LogoutBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof logout>>,
        TError,
        {data: LogoutBody},
        TContext
      > => {

      const mutationOptions = getLogoutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Login with email and password
 */
export const login = (
    loginRequest: LoginRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<LoginResponse>(
      {url: `/api/v1/auth/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loginRequest, signal
    },
      );
    }
  


export const getLoginMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginRequest}, TContext> => {

const mutationKey = ['login'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof login>>, {data: LoginRequest}> = (props) => {
          const {data} = props ?? {};

          return  login(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LoginMutationResult = NonNullable<Awaited<ReturnType<typeof login>>>
    export type LoginMutationBody = LoginRequest
    export type LoginMutationError = unknown

    /**
 * @summary Login with email and password
 */
export const useLogin = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof login>>,
        TError,
        {data: LoginRequest},
        TContext
      > => {

      const mutationOptions = getLoginMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Authenticated user changes their own password — issues a fresh token pair (a token already in hand keeps its old mustChangePassword claim until re-issued)
 */
export const changePassword = (
    changePasswordBody: ChangePasswordBody,
 signal?: AbortSignal
) => {
      
      
      return apiClient<RefreshResponse>(
      {url: `/api/v1/auth/change-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: changePasswordBody, signal
    },
      );
    }
  


export const getChangePasswordMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,{data: ChangePasswordBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,{data: ChangePasswordBody}, TContext> => {

const mutationKey = ['changePassword'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changePassword>>, {data: ChangePasswordBody}> = (props) => {
          const {data} = props ?? {};

          return  changePassword(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChangePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof changePassword>>>
    export type ChangePasswordMutationBody = ChangePasswordBody
    export type ChangePasswordMutationError = unknown

    /**
 * @summary Authenticated user changes their own password — issues a fresh token pair (a token already in hand keeps its old mustChangePassword claim until re-issued)
 */
export const useChangePassword = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,{data: ChangePasswordBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changePassword>>,
        TError,
        {data: ChangePasswordBody},
        TContext
      > => {

      const mutationOptions = getChangePasswordMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    